"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walkAndReplace = void 0;
/**
 * @hidden
 */
function walkAndReplace(value, options, pointer) {
    if (pointer === void 0) { pointer = []; }
    if (options.beforeWalk) {
        value = options.beforeWalk(value, pointer);
    }
    if (Array.isArray(value)) {
        var newValue = [];
        for (var i = 0; i < value.length; i++) {
            var entryValue = value[i];
            entryValue = walkAndReplace(entryValue, options, pointer.concat("".concat(i)));
            newValue.push(entryValue);
        }
        value = newValue;
    }
    else if (typeof value === 'object' && value !== null) {
        var newValue = {};
        var keys = Object.keys(value);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var entryKey = keys_1[_i];
            var entryValue = value[entryKey];
            entryValue = walkAndReplace(entryValue, options, pointer.concat(entryKey));
            newValue[entryKey] = entryValue;
        }
        value = newValue;
    }
    if (options.afterWalk) {
        value = options.afterWalk(value, pointer);
    }
    return value;
}
exports.walkAndReplace = walkAndReplace;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSnNvbldhbGtlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvdXRpbHMvSnNvbldhbGtlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFRQTs7R0FFRztBQUNILFNBQWdCLGNBQWMsQ0FDNUIsS0FBVSxFQUNWLE9BQThCLEVBQzlCLE9BQXNCO0lBQXRCLHdCQUFBLEVBQUEsWUFBc0I7SUFFdEIsSUFBSSxPQUFPLENBQUMsVUFBVSxFQUFFO1FBQ3RCLEtBQUssR0FBRyxPQUFPLENBQUMsVUFBVSxDQUFDLEtBQUssRUFBRSxPQUFPLENBQUMsQ0FBQztLQUM1QztJQUVELElBQUksS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsRUFBRTtRQUN4QixJQUFNLFFBQVEsR0FBRyxFQUFFLENBQUM7UUFDcEIsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEtBQUssQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUU7WUFDckMsSUFBSSxVQUFVLEdBQUcsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQzFCLFVBQVUsR0FBRyxjQUFjLENBQUMsVUFBVSxFQUFFLE9BQU8sRUFBRSxPQUFPLENBQUMsTUFBTSxDQUFDLFVBQUcsQ0FBQyxDQUFFLENBQUMsQ0FBQyxDQUFDO1lBQ3pFLFFBQVEsQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUM7U0FDM0I7UUFDRCxLQUFLLEdBQUcsUUFBUSxDQUFDO0tBQ2xCO1NBQU0sSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLElBQUksS0FBSyxLQUFLLElBQUksRUFBRTtRQUN0RCxJQUFNLFFBQVEsR0FBRyxFQUFFLENBQUM7UUFDcEIsSUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNoQyxLQUF1QixVQUFJLEVBQUosYUFBSSxFQUFKLGtCQUFJLEVBQUosSUFBSSxFQUFFO1lBQXhCLElBQU0sUUFBUSxhQUFBO1lBQ2pCLElBQUksVUFBVSxHQUFHLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztZQUNqQyxVQUFVLEdBQUcsY0FBYyxDQUN6QixVQUFVLEVBQ1YsT0FBTyxFQUNQLE9BQU8sQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLENBQ3pCLENBQUM7WUFDRixRQUFRLENBQUMsUUFBUSxDQUFDLEdBQUcsVUFBVSxDQUFDO1NBQ2pDO1FBQ0QsS0FBSyxHQUFHLFFBQVEsQ0FBQztLQUNsQjtJQUVELElBQUksT0FBTyxDQUFDLFNBQVMsRUFBRTtRQUNyQixLQUFLLEdBQUcsT0FBTyxDQUFDLFNBQVMsQ0FBQyxLQUFLLEVBQUUsT0FBTyxDQUFDLENBQUM7S0FDM0M7SUFFRCxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUM7QUFyQ0Qsd0NBcUNDIn0=